export default "__VITE_ASSET__gfp0logA__"